var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("summary-section-layout", {
    attrs: {
      id: "liabilities",
      "section-title": _vm.$t("application-standalone.labels.liabilities"),
      "has-missing-information": _vm.hasMissingInformation,
      "section-visibility-values": _vm.sectionVisibilityValues,
    },
    on: {
      edit: function ($event) {
        return _vm.$emit("edit")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var applicant = ref.applicant
          return [
            !_vm.applicantHasLiabilities(applicant.liabilities)
              ? _c("p", { staticClass: "grey-text" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.pages.liabilities.noLiabilities"
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(applicant.liabilities, function (liability, liabilityIndex) {
              return _c("p", { key: liabilityIndex }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.liabilitySummarySubtitle(liability)) +
                    "\n    "
                ),
              ])
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }